export const check_contact = (contact: any): void => {
    const required = ['email', 'type'];
    for (let r of required) {
        if (!contact[r]) {
            throw { type: 'warning', message: `Missing ${r}.` }
        }
    }
}